import { CSSProperties, FC, useState } from "react";
import { Sanitized } from "../../../common/components/Sanitized";
import { GenericTabs } from "../../../common/components/GenericTabs";
import { Tactic } from "../../../types/TacticTypes";

interface TacticContentProps {
    tactic: Tactic;
    contentStyle?: CSSProperties;
    onTabChange?: () => void;
}

export const TacticContent: FC<TacticContentProps> = ({ tactic, contentStyle, onTabChange }) => {
    const [selectedSection, setSelectedSection] = useState("0");

    const sections = tactic.contentV1?.map((item, index) => ({
        label: item.key
            .replace(/<[^>]*>/g, "")
            .replace(/[\t\n\r\f\v]/g, "")
            .trim()
            .replace(/^(\d\. *)/, "0$1"),
        value: item.value.replace(
            /^(<h2[^>]*>\s*<strong[^>]*>.*?)(\d)(\..*?<\/strong>\s*<\/h2>)/,
            "$10$2$3"
        ),
        key: index.toString(),
    }));

    const currentSection = sections?.find((item) => item.key === selectedSection);

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
            <GenericTabs
                activeKey={selectedSection}
                onChange={(key) => {
                    setSelectedSection(key);
                    onTabChange?.();
                }}
                items={sections?.map((item) => ({
                    label: <Sanitized content={item.label} />,
                    key: item.key,
                }))}
            />
            <div
                style={{
                    flex: 1,
                    overflow: "auto",
                    background: "#fafafa",
                    padding: 16,
                    ...contentStyle,
                }}
            >
                <Sanitized className="il-summary" content={currentSection?.value || ""} />
            </div>
        </div>
    );
};
